function fetchAPI(url, method, body, headers) {
    return fetch(url, {
        method: method,
        mode: 'cors',
        redirect: 'follow',
        body: body ? JSON.stringify(body) : body,
        headers: new Headers({ 'content-type': 'application/json' }),
    }).then((response) => {
        if (response.ok) {
            return response.json();
        } else {
            return response.json().then((d) => Promise.reject(d));
        }
    });
}

let allProducts = [];
export function invalidateCache() {
    allProducts = [];
}
export async function getAllProducts(category) {
    if (allProducts.length === 0) {
        let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/products', 'GET');
        allProducts = data;
    }
    if (category) {
        let filteredData = allProducts.filter((line) => {
            for (let k of Object.keys(line)) {
                if (typeof line[k] === 'string') {
                    if (line['category'] === category) return true;
                }
            }
            return false;
        });
        return filteredData;
    }
    return allProducts;
}

export async function getAllCategories() {
    if (allProducts.length === 0) {
        let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/products', 'GET');
        allProducts = data;
    }
    let categories = new Set();
    for (let p of allProducts) {
        categories.add(p.category);
    }

    let allCategories = Array.from(categories.values());

    // Force navidad priority
    if (allCategories.indexOf('Selección de Navidad') !== -1) {
        allCategories.splice(allCategories.indexOf('Selección de Navidad'), 1);
        allCategories.unshift('Selección de Navidad');
    }

    return allCategories;
}

// export async function getAllProducts(page, pageSize, category) {
//     if (allProducts.length === 0 || page === 0) {
//         let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/products', 'GET');
//         allProducts = data;
//     }
//     if (category) {
//         let filteredData = allProducts.filter((line) => {
//             for (let k of Object.keys(line)) {
//                 if (typeof line[k] === 'string') {
//                     if (line['category'] === category) return true;
//                 }
//             }
//             return false;
//         });
//         return { data: filteredData.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: filteredData.length };
//     }
//     return { data: allProducts.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: allProducts.length };
// }

// export async function getAllProducts(page, pageSize, search) {
//     if (allProducts.length === 0 || page === 0) {
//         let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/products', 'GET');
//         allProducts = data;
//     }
//     if (search) {
//         search = search.toLowerCase();
//         let filteredData = allProducts.filter((line) => {
//             for (let k of Object.keys(line)) {
//                 if (typeof line[k] === 'string') {
//                     if (line[k].toLowerCase().indexOf(search) !== -1) return true;
//                 }
//             }
//             return false;
//         });
//         return { data: filteredData.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: filteredData.length };
//     }
//     return { data: allProducts.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: allProducts.length };
// }

export async function create(customer, cart, deliveryDate, deliveryTime) {
    let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/order', 'PUT', {
        customer: customer,
        lines: cart.map((l) => ({
            quantity: l.quantity,
            product: {
                id: l.id,
                cut: l.cut,
                format: l.format,
            },
        })),
        deliveryDate,
        deliveryTimeRange: deliveryTime,
    });
    return data;
}

export async function checkRouteAvailability(postalCode) {
    let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/route-availability', 'PUT', { postalCode });
    return data;
}

export async function checkStorePickupAvailability(postalCode) {
    let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/store-availability', 'GET');
    return data;
}

export async function verify(orderId, verificationCode) {
    let data = await fetchAPI(`https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/order/${orderId}`, 'PUT', { verificationCode });
    return data;
}

export async function getLoyaltyCard(loyaltyCode, identifier) {
    let data = await fetchAPI('https://p162h8xv6d.execute-api.eu-west-1.amazonaws.com/prod/loyalty-card', 'POST', {
        loyaltyCode,
        identifier,
    });
    return data;
}
